import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const fileUrl = (path) => (path ? `${BACKEND_URL}${path}` : "");

export const resolveImg = (u) => (!u ? "" : /^https?:\/\//.test(u) ? u : `${BACKEND_URL}${u}`);

// Small, cacheable thumbnail for hosted files (adds ?w=). Leaves external/CDN URLs untouched and
// only rewrites our own /api/files/ paths; falls back to the full image if there's no path.
export const thumbUrl = (u, w = 320) => {
  if (!u) return "";
  if (/^https?:\/\//.test(u)) return u.includes("/api/files/") ? `${u}${u.includes("?") ? "&" : "?"}w=${w}` : u;
  if (u.startsWith("/api/files/")) return `${BACKEND_URL}${u}?w=${w}`;
  return `${BACKEND_URL}${u}`;
};

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("pb_token")) {
      localStorage.removeItem("pb_token");
      if (!window.location.pathname.startsWith("/login")) window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
